// =========================================================
// Source unique de vérité pour les coordonnées du site.
// Modifier ici = mis à jour partout (header, footer, contact,
// mentions légales, données structurées SEO).
// =========================================================

export const CONTACT = {
  name: "Tanguy Perroit",
  role: "Photographe professionnel",

  email: "tanguyperroitpro@outlook.fr",

  phone: {
    display: "06 21 73 58 12",
    international: "+33621735812",
    href: "tel:+33621735812",
  },

  location: {
    display: "Joué-lès-Tours, France",
    city: "Joué-lès-Tours",
    postalCode: "37300",
    street: "13 Rue de l'Arche",
    region: "Centre-Val de Loire",
    country: "France",
    mapsUrl: "https://maps.google.com/?q=Jou%C3%A9-l%C3%A8s-Tours,France",
  },

  social: {
    instagram: "https://www.instagram.com/tanguyperroitpro",
    linkedin: "https://www.linkedin.com/in/tanguy-perroit/",
  },

  legal: {
    siret: "921 908 117 00010",
  },
};

export const MAILTO = `mailto:${CONTACT.email}`;
export const TEL_HREF = CONTACT.phone.href;

export default CONTACT;
